import { calculate, sendEmail } from '../api/postcodeApi';
import { CALCULATE_POSTCODE, RESPONSE_ERROR, EMAIL_RESULTS_ERROR, NOT_FOUND_ERROR } from './types';
import { errorMessage } from '../components/common/messageComponents/toaster';
import { storage, PLUGIN_NAME } from '../constants'
import { emailInfo } from '../constants/emailInfo'
import { emailMessage } from './notification';
import { constructValues } from '../utils'
/**
 * @param {apiUrl} //base url values
 * @param {values} //object
 */

export const calculatePostcode = (values) => async (dispatch) => {
    try {
        //adding initial load value to check value for initial load
        localStorage.setItem(storage.INITIAL_VALUE, JSON.stringify(values));
        const response = await calculate(values);
        dispatch({
            type: CALCULATE_POSTCODE,
            payload: { ...response.data.data, ...values }
        });
    } catch (error) {
        const postCodeUnavailable = error?.response?.status === 404 || false;
        // Dispatch the appropriate action based on whether the postcode is unavailable (404) or another error occurred
        dispatch({
            type: postCodeUnavailable ? NOT_FOUND_ERROR : RESPONSE_ERROR
        });
        errorMessage(error);
        throw error
    }
};

export const mailPostcode = (values) => async (dispatch, getState) => {
    try {
        //getting redux state value using getState
        const { postcode, lender1, lender2 } = getState().postcode
        const obj_to_send = {
            receipentEmailAddress: values.email,
            data: {
                postcode,
                results: constructValues(lender1, lender2)
            },
            emailType: emailInfo.EMAIL_TYPE,
            isActiveCampaignSubscribe: true,
            pluginName: PLUGIN_NAME
        }
        await sendEmail(obj_to_send);
        dispatch(emailMessage());
    } catch (error) {
        dispatch({
            type: EMAIL_RESULTS_ERROR
        });
        errorMessage(error);
        throw error;
    }
};
